export enum DeliveryNoteTypeView {
  DeliveryNote = 'DN',
  HandlingUnit = 'HU',
}
